import {BaseActionButton} from './BaseActionButton';

class AddNode extends BaseActionButton {
  createNode = (role) => {
    const {rackStore, selection} = this.rackEditorStore;

    this.hidePopups(true, true);
    const newNode = rackStore.addNode(role);
    selection.select(newNode.id);
    rackStore.calculateZonesSizes();
  };
}

export {AddNode};
